module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_6005.ea28fdc2.png";